import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import { SvgIcon } from '@mui/material'

interface CliniqueInfoContentProps {
  Icon: typeof SvgIcon,
  label: string,
}
interface CliniqueInfoLineProps extends CliniqueInfoContentProps {
  type?: 'tel'|'mailto',
}

/* eslint-disable react/no-danger */
const CliniqueInfoContent = ({ Icon, label }: CliniqueInfoContentProps) => (
  <div className={css(styles.container)}>
    <div className={css(styles.iconContainer)}><Icon /></div>
    <div dangerouslySetInnerHTML={{ __html: label }} />
  </div>
)

const CliniqueInfoLine = ({ Icon, label, type }: CliniqueInfoLineProps) => {
  if (!type) {
    return <CliniqueInfoContent Icon={Icon} label={label} />
  }
  return (
    <a href={`${type}:${label}`}>
      <CliniqueInfoContent Icon={Icon} label={label} />
    </a>
  )
}
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    fontSize: '18px',
    marginBottom: '6px',
  },
  iconContainer: {
    width: '36px',
  },
})
CliniqueInfoLine.defaultProps = {
  type: null,
}
export default CliniqueInfoLine
